import axios from 'axios';

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api`,
});

// Add a request interceptor to include the auth token
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle token refresh
instance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        
        // If error is 401 (Unauthorized) and we haven't already retried this request
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            const refreshToken = localStorage.getItem('refreshToken');
            
            if (refreshToken) {
                try {
                    // Call the refresh endpoint directly using a clean axios request (to avoid request interceptor loops)
                    const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/refresh`, {
                        refreshToken,
                    });
                    
                    if (res.status === 200) {
                        const { token, refreshToken: newRefreshToken } = res.data;
                        
                        // Save the new tokens
                        localStorage.setItem('token', token);
                        localStorage.setItem('refreshToken', newRefreshToken);
                        
                        // Update authorization header on the original request and retry
                        originalRequest.headers.Authorization = `Bearer ${token}`;
                        return instance(originalRequest);
                    }
                } catch (refreshError) {
                    console.error('Refresh token failed:', refreshError);
                    // Clear storage and trigger user logout
                    localStorage.removeItem('token');
                    localStorage.removeItem('refreshToken');
                    window.dispatchEvent(new Event('auth_logout'));
                }
            }
        }
        return Promise.reject(error);
    }
);

export default instance;
